var $ = require('jquery');
var popup = require('./popup');
const get = require('lodash').get;

module.exports = {
  init: function(callback) {
    let readOnly = window.location.href.indexOf('read-only=true') > 0;
    if (get(globals, 'popups.showNewTerms', false) && !readOnly) {
      popup.newTerms();
    } else if (get(globals, 'popups.showNewPrivacyPolicy', false) && !readOnly) {
      popup.newPrivacyPolicy();
    }
    /*
    if (get(globals, 'popups.showPollPopup', false)) {
      popup.pollMessage(callback);
    }
    */

    if (get(globals, 'initLogin', false)) {
      if (callback && typeof op_tour_params !== 'undefined') {
        callback();
      } else if (get(globals, 'popups.profileVerification', false)) {
        popup.profileVerificationMessage(callback);
      } else if (get(globals, 'popups.noEmail', false)) {
        popup.verificationMessage(callback);
      } else if (get(globals, 'popups.imageUpload', false)) {
        const query = '?show_profile_image_text=1';
        popup.imageUpload(query);
      } else if (get(globals, 'currentmember.status', '') == 'unverified') {
        popup.unverifiedmessage(callback);
      } else if (get(globals, 'popups.invalidcard', '') == 'unverified') {
        popup.invalidcardmessage(callback);
      }
      return 1;
    }

    if (callback) {
      callback();
    }
  },
};
